document.addEventListener("DOMContentLoaded", function () {
  const button = document.querySelector(".localization__button");
  const listWrapper = document.querySelector(".localization__list-wrapper");
  const selectedLanguage = document.querySelector(".selected-language");
  const items = document.querySelectorAll(".localization__item");
  const hiddenInput = document.querySelector("input[name='locale_code']");

  button.addEventListener("click", function () {
      listWrapper.classList.toggle("active");
  });

  items.forEach(item => {
      item.addEventListener("click", function () {
          const lang = this.getAttribute("data-lang");
          selectedLanguage.textContent = this.textContent;
          hiddenInput.value = lang;
          listWrapper.classList.remove("active");
          
          items.forEach(i => i.style.display = "block");
          this.style.display = "none";
      });
  });

  document.addEventListener("click", function (event) {
      if (!button.contains(event.target) && !listWrapper.contains(event.target)) {
          listWrapper.classList.remove("active");
      }
  });
});